import * as React from "react"
import styled, { css } from "styled-components"

import Badge from "~/components/atoms/Badge"
import Icon, { IconType } from "~/components/atoms/Icon"
import Link from "~/components/atoms/Link"
import { Color, SpacingSize, TextSize, Z } from "~/consts/style-mixins"

interface Props {
  items: Item[]
  selectedTabIndex?: number
  className?: string
}

interface Item {
  name: string
  icon: IconType
  href: string
  notificationCount?: number
}

interface StyledProps {
  itemNum: number
  selected?: boolean
}

const { useState } = React

const TabBar = ({ items, selectedTabIndex }: Props) => {
  const [selected, selectTab] = useState(selectedTabIndex || 0)

  return (
    <StyledTabBarWrapper>
      <StyledTabBarContainer>
        {items.map((item: Item, index) => {
          return (
            <Link href={item.href} key={index}>
              <StyledTabBarItem
                key={index}
                itemNum={items.length}
                selected={selected === index}
                onClick={() => selectTab(index)}
              >
                <StyledIconWrapper>
                  <Icon type={item.icon} size={24} color={selected === index ? Color.Primary : Color.LightGray} />
                  {item.notificationCount !== undefined && item.notificationCount > 0 && (
                    <Badge count={item.notificationCount} className="badge" />
                  )}
                </StyledIconWrapper>
                {item.name}
              </StyledTabBarItem>
            </Link>
          )
        })}
      </StyledTabBarContainer>
    </StyledTabBarWrapper>
  )
}

const StyledTabBarWrapper = styled.div`
  width: 100%;
  border-top: 1px solid ${Color.BorderGray};
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background: white;
  position: fixed;
  bottom: 0;
  z-index: ${Z.Tab};
`

const StyledTabBarContainer = styled.div`
  padding: ${SpacingSize.XS}px 0;
`

const StyledTabBarItem = styled.div`
  display: inline-flex;
  flex-direction: column;
  text-align: center;
  font-size: ${TextSize["2XS"]}px;
  color: ${Color.LightGray};
  ${({ itemNum }: StyledProps) => css`
    width: ${100 / itemNum}%;
  `}
  ${({ selected }: StyledProps) => css`
    ${selected &&
    `
      Color: ${Color.Primary}
      font-weight: bold;
    `}
  `}
  &:hover {
    cursor: pointer;
  }
`

const StyledIconWrapper = styled.div`
  position: relative;
  margin-bottom: 4px;
  .badge {
    position: absolute;
    bottom: -2px;
    right: 16px;
  }
`

export default TabBar
